import {
  AppModeSelector,
  LoadingPage,
  PageMetaHandler,
  PWAInstallWrapper,
  ProtectedRoute,
} from "@shared/ui";
import useInvalidateQueriesOnLanguageChange from "@shared/hooks/common/useInvalidateQueriesOnLanguageChange";
import { useInitializeApp } from "@shared/hooks/common/useInitializeApp";
import useCheckInviteToken from "@shared/hooks/user/useCheckInviteToken";
import useCheckToken from "@shared/hooks/user/useCheckToken";
import { RootState } from "@app/store/store";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import getAuthRoutes from "@app/routes/authRoutes";
import ClinicRoutes from "@app/routes/clinicRoutes";
import getClinicSettingsRoutes from "@app/routes/clinicSettingsRoutes";
import EventRoutes from "@app/routes/eventRoutes";
import getEventSettingsRoutes from "@app/routes/eventSettingsRoutes";
import getPatientRoutes from "@app/routes/patientRoutes";
import getUserRoutes from "@app/routes/userRoutes";
import "@/styles/app.scss";

function App() {
  const { isInitializingApp } = useSelector((state: RootState) => state.app);
  useCheckToken();
  useInitializeApp();
  useCheckInviteToken();
  useInvalidateQueriesOnLanguageChange();

  if (isInitializingApp) {
    return <LoadingPage />;
  }

  return (
    <>
      <PageMetaHandler />
      <Routes>
        {getAuthRoutes()}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppModeSelector />
            </ProtectedRoute>
          }
        />
        {ClinicRoutes()}
        {getClinicSettingsRoutes()}
        {getEventSettingsRoutes()}
        {getPatientRoutes()}
        {EventRoutes()}
        {getUserRoutes()}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <AppModeSelector />
            </ProtectedRoute>
          }
        />
      </Routes>
      <PWAInstallWrapper />
    </>
  );
}

export default App;
